import styled from 'styled-components';
import { palette } from 'styled-tools';

import { minWidth } from '@calm-web/design-system';

import FullscreenBackground from '@/components/image/FullscreenBackground';
import GridWrapper from '@/components/ui/GridWrapper';

export const Background = styled(FullscreenBackground)`
	display: none;
	height: 420px;

	${minWidth('desktop')} {
		display: block;
		height: 100%;
		position: fixed;
		right: 50%;

		& > div {
			width: 200%;
		}
	}

	&:after {
		background: rgba(0, 0, 0, 0.4);
		bottom: 0;
		content: '';
		left: 0;
		position: absolute;
		right: 0;
		top: 0;
	}
`;

export const Grid = styled(GridWrapper)`
	grid-template-columns: 1fr;
	margin: 0;

	${minWidth('tablet')} {
		margin: 0 auto;
		max-width: none;
		width: 100%;
	}

	${minWidth('desktop')} {
		grid-gap: 76px;
		grid-template-columns: 1fr 1fr;
		margin: 0 36px;
		max-width: 960px;
	}

	${minWidth('desktopLarge')} {
		grid-gap: 116px;
		margin: 0 48px;
		max-width: 1168px;
	}
`;

export const Form = styled.div`
	margin: 0 auto;
	max-width: 480px;
	padding: 24px 16px;

	${minWidth('tablet')} {
		padding: 40px 24px;
	}

	${minWidth('desktop')} {
		max-width: 960px;
		padding: 140px 0 40px;
	}

	${minWidth('desktopLarge')} {
		max-width: 1168px;
	}
`;

export const Wrapper = styled.div`
	border-bottom: 1px ${palette('gray4')} solid;
	margin-bottom: 32px;
	padding-bottom: 12px;
`;

export const TitleWrapper = styled.div`
	display: flex;
	padding-bottom: 20px;
`;

export const AmexLogo = styled.img`
	flex: 0 0 60px;
	height: 60px;
	width: 60px;
	margin-top: 8px;
	margin-right: 20px;

	${minWidth('tablet')} {
		flex: 0 0 80px;
		height: 80px;
		margin-right: 32px;
		width: 80px;
	}

	${minWidth('desktop')} {
		flex: 0 0 100px;
		height: 100px;
		width: 100px;
	}
`;
